import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import agencyApi from "api/agencyApi";
import { formatQueryParams } from "helpers/format";

export const getAgencyList = createAsyncThunk(
  "Agency",
  async (params: any = {}) => {
    try {
      const response = await agencyApi.agencyList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getAgencyDetail =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await agencyApi.getAgencyDetail(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postAgency = async (data: any = {}) => {
  try{
    const response = await agencyApi.createAgency(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putAgency = async (id: string | number , data: any = {}) => {
  try{
    const response = await agencyApi.updateAgency(id, data);
    return response;
  }catch (error) {
    return error;
  }
};